import * as React from 'react';
import Spinner from '../spinner';
import { Container, Overlay, LoadingIndicatorContainer, LoadingLabel } from './Loader.styles';

export const Loader = (props) => {
  return (
    <Container>
      <Overlay visible={props.visible}>
        <LoadingIndicatorContainer>
          <Spinner size={30} />
          {props.label && <LoadingLabel>{props.label}</LoadingLabel>}
        </LoadingIndicatorContainer>
      </Overlay>
      {props.children}
    </Container>
  );
};
